module.exports = __webpack_public_path__ + "img/P4-3-3.578eb13f.svg";